export default __webpack_public_path__ + "static/Agile-Processes-ec225a9f7666c87e3d9ad4a3e36f1937.webp";